module.exports = __webpack_public_path__ + "static/img/cont1403.df15d6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont1403.jpg
// module id = BfF4
// module chunks = 0